import { createStore, applyMiddleware } from 'redux';
import rootReducer from './modules/reducer'; // Importa tus reducers
import thunk from 'redux-thunk'; // Importa middleware u otras dependencias que necesites

const middleware = [thunk]; // Puedes agregar más middleware si es necesario

const store = createStore(rootReducer, applyMiddleware(...middleware));

export default store;
